// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__HQRLK","modalContent":"styles_modalContent__C-tUO"};